export const getTranslatedLocaleNames = (
  targetLocale: string,
  locales: string[],
): string[] => {
  if (!Intl.DisplayNames) {
    return locales;
  }

  const displayNames = new Intl.DisplayNames([targetLocale], {
    type: 'language',
  });

  return locales.map((locale) => displayNames.of(locale) ?? locale);
};
